import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaGlobe, FaMobileAlt, FaShoppingCart, FaLightbulb } from "react-icons/fa";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import "./ServicesCardsHome.css";

const CARDS = [
  {
    icon: FaGlobe,
    title: "Sites Web & Landing Pages",
    subtitle: "Sites modernes, rapides et adaptes mobile",
    price: "A partir de 150 000 FCFA",
    to: "/services/developpement-web",
  },
  {
    icon: FaMobileAlt,
    title: "Applications Mobiles",
    subtitle: "iOS et Android sur mesure pour vos clients",
    price: "A partir de 500 000 FCFA",
    to: "/services/applications-mobiles",
  },
  {
    icon: FaShoppingCart,
    title: "E-commerce",
    subtitle: "Boutiques en ligne avec Orange Money et Wave",
    price: "A partir de 300 000 FCFA",
    to: "/services/applications-e-commerce",
  },
  {
    icon: FaLightbulb,
    title: "Solutions par secteur",
    subtitle: "Restaurants, boutiques, transport, sante...",
    price: "Adapte a votre metier",
    to: "/solutions",
  },
];

export default function ServiceCardsHome() {
  const { pathname } = useLocation();
  useScrollReveal();

  return (
    <section className="service-cards">
      {CARDS.map((c, i) => {
        const Icon = c.icon;
        return (
          <Link
            key={c.title}
            to={c.to}
            state={{ from: pathname }}
            className="sc-card-link"
            aria-label={c.title}
            data-reveal="scale"
            data-delay={i * 80}
          >
            <div className="sc-card">
              <div className="sc-icon">
                <Icon size={28} />
              </div>
              <h3>{c.title}</h3>
              <p className="sc-sub">{c.subtitle}</p>
              <p className="sc-price">{c.price}</p>
              <span className="sc-see-more">En savoir plus →</span>
            </div>
          </Link>
        );
      })}
    </section>
  );
}
